import { render, staticRenderFns } from "./LessonsHeader.vue?vue&type=template&id=5a4a80fa&scoped=true&"
import script from "./LessonsHeader.vue?vue&type=script&lang=ts&"
export * from "./LessonsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LessonsHeader.vue?vue&type=style&index=0&id=5a4a80fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a80fa",
  null
  
)

export default component.exports